import React from 'react';

import exportFile, {CSVTYPE, PDFTYPE} from "../../functions/exportFile";
import APIHelper from "../../hooks/useAPIHelper";

import {ExportButtonCtn} from "./index.style";

interface ExportButtonProps {
  data: {};
  columns: [],
}

const ExportButton: React.FC<ExportButtonProps> = ({data, columns}) => {
  const exportInfo = APIHelper();

  const handleExport = (type: string) => {
    exportInfo.run(exportFile, () => {}, [data, type, columns]);
  };

  return (
    <React.Fragment>
      <ExportButtonCtn onClick={() => {
        handleExport(CSVTYPE);
      }}
      >
        EXPORT DATA
      </ExportButtonCtn>
    </React.Fragment>
  )

};

export default ExportButton;